export default __webpack_public_path__ + "static/media/guide-2.ffcb75b0.png";